var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.188,
    height: 19.981,
    viewBox: "0 0 16.188 19.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8698",
    "data-name": "\\uC0AC\\uAC01\\uD615 8698",
    width: 16.188,
    height: 19.981,
    fill: "#222"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7513",
    "data-name": "\\uADF8\\uB8F9 7513",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7513-2",
    "data-name": "\\uADF8\\uB8F9 7513",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12453",
    "data-name": "\\uD328\\uC2A4 12453",
    d: "M10.17,9.339A4.67,4.67,0,1,0,5.5,4.67a4.675,4.675,0,0,0,4.67,4.67m0-8.094A3.424,3.424,0,1,1,6.745,4.67,3.428,3.428,0,0,1,10.17,1.245",
    transform: "translate(-2.076 0)",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12454",
    "data-name": "\\uD328\\uC2A4 12454",
    d: "M8.094,15.909A8.1,8.1,0,0,0,0,24v1.359a.623.623,0,1,0,1.245,0V24a6.849,6.849,0,0,1,13.7,0v1.359a.623.623,0,1,0,1.245,0V24a8.1,8.1,0,0,0-8.094-8.094",
    transform: "translate(0 -6.004)",
    fill: "#222"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.785b0dc9c8f585e2c4e33bee3996d39b.svg";
export { ForwardRef as ReactComponent };